import { render, staticRenderFns } from "./match-details.vue?vue&type=template&id=5bdbaec9&scoped=true&"
import script from "./match-details.vue?vue&type=script&lang=ts&"
export * from "./match-details.vue?vue&type=script&lang=ts&"
import style0 from "./match-details.vue?vue&type=style&index=0&id=5bdbaec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbaec9",
  null
  
)

export default component.exports